const usePermissionConfig = () => {
  return {
    /*
    * 款式号
    * 控制：跳转订单信息编辑
    * 跳转路由名称：ProductionDemandOrderEdit
    * */
    EDIT: 'OPS-PRODUCTION-DEMAND-ORDER-EDIT',
    /*
    * 提交
    * 控制：提交订单信息
    * 跳转路由名称：
    * */
    SUBMIT: 'OPS-PRODUCTION-DEMAND-ORDER-SUBMIT',
  };
};

export default usePermissionConfig;
